import styled from "styled-components";
import React, { useEffect, useState } from "react";

import { Message, Modal, Input } from 'semantic-ui-react'
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import Select from "react-select";


import {
    SG_COPY_EMAIL_TEMPLATE,
    SG_EMAIL_TEMPLATE_SELECT,
    GET_AM_ORGANIZATION
} from "constants/actions";

const QUERY_PARAMS = "organization"

const CopyTemplate = ({ trigger,
    showCopyTemplate, setShowCopyTemplate }) => {
    const dispatch = useDispatch();
    const [pristine, setPristine] = useState(true)


    const [formErrors, setFormErrors] = useState([]);
    const [categoryName, setCategoryName] = useState('');
    const [categorySelected, setCategorySelected] = useState('');
    const [categoryList, setCategoryList] = useState([]);
    const [organizationSelect, setOrganizationSelect] = useState([])
    const [organizationSelected, setOrganizationSelected] = useState([])

    const [extOrganizationList, setExtOrganizationList] = useState([])

    const newQueryParameters = new URLSearchParams();


    const { get_email_template_select,
        get_organization_select } = useSelector(
            (state) => ({
                // get_email_template: state.emailTemplate.email_templates,
                get_email_template_select: state.emailTemplate.email_template_select,
                get_organization_select: state.organizations.organization_select,
            }),
            shallowEqual
        );

    useEffect(() => {
        if (get_email_template_select) {
            setCategoryList(get_email_template_select)
        }
    }, [get_email_template_select]);

    useEffect(() => {
        dispatch({
            type: SG_EMAIL_TEMPLATE_SELECT,
        });
    }, [dispatch]);

    useEffect(() => {
        setOrganizationSelect(
            get_organization_select.filter(or => !extOrganizationList.includes(or.id)))

    }, [get_organization_select, extOrganizationList]);


    useEffect(() => {
        setExtOrganizationList(get_email_template_select.map(ss => ss.organization))
    }, [get_email_template_select]);

    const onSubmit = () => {
        if (formErrors.length > 0) {
            setPristine(false)
            return
        }
        setPristine(true)
        dispatch({
            type: SG_COPY_EMAIL_TEMPLATE,
            payload: {
                organization_id: organizationSelected?.id,
                name: categoryName,
                ext_email_template_id: categorySelected.id
            },
        });
        dispatch({
            type: GET_AM_ORGANIZATION,
            payload: organizationSelected
        });
        setShowCopyTemplate(false)
        newQueryParameters.set(QUERY_PARAMS, organizationSelected.id)
    }

    useEffect(() => {
        const ErrorList = []
        if (!categoryName) {
            ErrorList.push("Enter a Name")
        }
        if (!organizationSelected?.id) {
            ErrorList.push("No Organization Found")
        }
        setFormErrors(ErrorList)
    }, [categoryName, pristine, organizationSelected]);

    function ChangedOrganization(e) {
        setOrganizationSelected(e)
    }

    return (
        <Modal
            onClose={() => setShowCopyTemplate(false)}
            open={showCopyTemplate}
            trigger={trigger}
            size={"small"}
        >
            <Modal.Header>
                Create a Email template with name
            </Modal.Header>
            <div style={{ display: 'flex' }}>
                <Half>
                    {formErrors.length > 0 && !pristine &&
                        <Message negative
                            //   onDismiss={clearErrors}
                            header='We need these details!'
                            list={formErrors}
                        />
                    }

                    <FormContainer>
                        <Label>Copy From This One</Label>
                        <Select
                            name="survey_preference"
                            options={categoryList}
                            onChange={setCategorySelected}
                            getOptionLabel={(option) => `${option.organization_name? option.organization_name : "Generic"} - ${option.name}`}
                            getOptionValue={(option) => `${option.id}`}
                            value={categorySelected}
                        />
                    </FormContainer>

                    <FormContainer>
                        <Label>Target Organization</Label>
                        <Select
                            name="survey_preference"
                            options={organizationSelect}
                            onChange={ChangedOrganization}
                            getOptionLabel={(option) => `${option.name}`}
                            getOptionValue={(option) => `${option.id}`}
                            value={organizationSelected}
                        />
                    </FormContainer>

                    <FormContainer>
                        <Label>Email Template Name</Label>
                        <Input
                            fluid
                            placeholder='Email Template Name'
                            name="name"
                            type="text"
                            // defaultValue={surveyStruc?.name}
                            value={categoryName}
                            onChange={(v) => setCategoryName(v.target.value)}
                        />
                    </FormContainer>


                    <Submit
                        floated='right'
                        disable={formErrors.length > 0 && !pristine}
                        onClick={onSubmit}>Create</Submit>
                </Half>
            </div>
        </Modal >
    )
}

export default CopyTemplate

const Half = styled.div`
	width:100%;
	padding:30px 30px;
`

const Label = styled.div`
	margin-bottom:10px;
	font-weight:bold;
`

const FormContainer = styled.div`
    width: 100%;
	margin-top:20px;
`

const Submit = styled.button`
	border-radius: 5px;
  background-color:${props => props.disable ? '#dcdcdc' : '#6a00ff'};
  font-size: 14px;
  font-weight: bold;
  color:white;
  padding: 10px;
  display:flex;
  align-items:center;
  justify-content:center;
  width:200px;
  margin-top:30px;
  cursor:${props => props.disable ? 'not-allowed' : 'pointer'};
  border:none;

`
